/* import __COLOCATED_TEMPLATE__ from './color-formatting.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import { DEFAULT_MESSENGER_COLORS } from 'embercom/lib/messenger-settings-defaults';

export default class ColorFormatting extends Component {
  colorOptions = DEFAULT_MESSENGER_COLORS;
}
